export default "static/src/components/Homepage/brochure_scuolalimes_2025_dig.pdf";